import Button from 'components/_UI/Button'
import Loader from 'components/_UI/Loader'
import Paginate from 'components/_UI/Paginate'
import Table from 'components/_UI/Table'
import Text from 'components/_UI/Text'
import ToastContainer from 'components/_UI/ToastsContainer'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'
import { useEvent } from 'context/events/Event'
import useToast from 'hooks/useToast'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import { BlockContent } from 'styled/UI/BlockContent'
import eventSectorsApi from 'api/requests/eventSectors'
import currency from 'helpers/currency';

export default function EventEstablishmentsTab() {
    const { event } = useEvent();
    const { toast, toasts } = useToast();

    const [allEstablishments, setAllEstablishments] = useState([]);
    const [filteredEstablishments, setFilteredEstablishments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [perPage, setPerpage] = useState(null);
    const [lastPage, setLastPage] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);
    const [totalItems, setTotalItems] = useState(null);
    const [appliedFilters, setAppliedFilters] = useState(null);

    useEffect(() => {
        getEventEstablishments();
    }, []);

    const listEstablishments = filteredEstablishments?.map(establishment => {
        return {
            name: <Text name='small'>{establishment?.name}</Text>,
            sector: <Text name='small'>{establishment?.sector_data?.name}</Text>,
            total_sold: <Text name='small'>{currency.format(establishment?.total_sold ?? 0)}</Text>,
        };
    })

    const getEventEstablishments = async () => {
        setLoading(true)

        try {
            const { data } = await eventSectorsApi.get(event?.slug);

            const establishments = data.data
                .map(sector => sector.establishments)
                .flat();

            setAllEstablishments(establishments)
            setFilteredEstablishments(establishments)

        } catch (error) {
            // console.log('error');

        } finally {
            setLoading(false)
        }
    }


    return (
        <Column>
            <ToastContainer toasts={toasts} />
            <Container>
                <>
                    <Column>
                        <HeaderContent>
                            <Text name='subtitle' paddingBottom={0} color={colors.nightDark}>
                                Lista de estabelecimentos
                            </Text>

                            <ButtonContainer>
                                <Button
                                    variant='disabled'
                                    category='squired'
                                >
                                    Baixar lista
                                </Button>
                            </ButtonContainer>
                        </HeaderContent>
                    </Column>

                    {
                        loading ? (
                            <ContentLoading>
                                <Loader />
                            </ContentLoading>
                        ) : (
                            allEstablishments.length > 0 ? (
                                <>
                                    <BlockContent>
                                        <Text name='highlight' color={colors.nightDark} paddingBottom={0} paddingTop={'10px'}>
                                            Estabelecimentos cadastrados
                                        </Text>
                                        <Table
                                            rows={listEstablishments}
                                            columns={['Nome', 'Setor', 'Total vendido']}
                                        />
                                        {
                                            lastPage > 1 &&
                                            <Paginate
                                                perPage={perPage}
                                                totalItems={totalItems}
                                                lastPage={lastPage}
                                                firstPage={1}
                                                currentPage={currentPage}
                                                marginTop={'30px'}
                                                onPaginate={(number) => getParticipants(number, appliedFilters)}
                                            />
                                        }
                                    </BlockContent>
                                </>
                            ) : (
                                <ContentNotResult>
                                    <NotResultDashBoard
                                        text={
                                            <Text name='highlight'>
                                                Não foram encontrados estabelecimentos no seu evento.
                                            </Text>
                                        }
                                        ilustration={'withoutParticipants'}
                                        marginTop={'15px'}
                                    />
                                </ContentNotResult>
                            )
                        )
                    }

                </>
            </Container>
        </Column >
    )
}

const Container = styled(Column)`
    padding-bottom: 20px;
`;

const ContentNotResult = styled.div`
    & > div {
        flex-direction: column;
    }

    & > div > picture {
        width: 45%;
    }

    & > div > div {
        width: 100%;
    }
`;

const HeaderContent = styled(Column)`
    width: 100%;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        & > h2 {
            width: auto
        }
    }
`;

const ButtonContainer = styled.span`
  width: 100%;
  margin-top: 20px;

  @media screen and (min-width: ${breakpoints.md}) {
    width: 152px;
    margin-top: 0;
  }
`;

const ContentLoading = styled(Column)`
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
`